import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';

interface ColumnActionsSectionProps {
  onRemove: () => void;
}

/**
 * Column actions section for PulseColumnMenu
 * Provides actions like removing a column from the table
 */
export const ColumnActionsSection: React.FC<ColumnActionsSectionProps> = ({
  onRemove,
}) => {
  return (
    <>
      {/* Section Title */}
      <div className="px-4 py-2 text-xs font-semibold text-neutral-500 uppercase tracking-wide text-left">
        Column Actions
      </div>

      {/* Remove Column Action */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        className="w-full px-4 py-2 text-sm text-left hover:bg-neutral-100 transition-colors flex items-center gap-2"
      >
        <Icon icon={faXmark} className="text-base text-neutral-500" />
        <span className="text-neutral-700">Remove Column</span>
      </button>
    </>
  );
};

export default ColumnActionsSection;
